// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1yRGZ","title":"AfterBackImages_title__2D0z7","images":"AfterBackImages_images__SFkDg"};